import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-profile-similarity',
  templateUrl: './profile-similarity.component.html',
  styleUrls: ['./profile-similarity.component.css']
})
export class ProfileSimilarityComponent implements OnInit {
  constructor(
    private apiService: ApiService,
    private router: Router,
    public translations: TranslationService
  ) { }

  userData:any = this.apiService.getUser();
  commonQuestions: Array<any> = [];
  questions: Array<any> = [];
  allUsersQues: Array<any> = [];
  profileForm = new FormGroup({ });
  profilesSelection: Array<any> = []; 
  profiles: Array<any> = []; 

  ngOnInit() {
    this.userData = this.apiService.user;
    this.apiService.getProfiles().subscribe((res: any) => {
      this.profiles = res.data;
      let allProfilesQuestions = res.data.map((profile) => profile.questions);

      this.commonQuestions = allProfilesQuestions[0].filter(ques => {
        let quesExistProfile2:any = allProfilesQuestions[1].filter(p2ques => p2ques._id == ques._id);
        let quesExistProfile3:any = allProfilesQuestions[2].filter(p3ques => p3ques._id == ques._id);
        if(quesExistProfile2.length != 0 && quesExistProfile3.length != 0) {
          let savedQuestions:any = this.userData.questions.filter((q) => q.question == ques.question);
          if(savedQuestions.length != 0) {
            ques.savedAnswer = savedQuestions[0].answers[0].text;
            this.questions.push(savedQuestions[0]);
          } else {
            this.questions.push({question: ques.question, answers: [{ text: ques.answers[0].text}]});
          }
          return ques;
        }
      });
    });
  }

  ngOnDestroy() {
  }

  answerChange(e, i) {
    this.questions[i].answers = [];
    this.questions[i].answers.push({ text: e.target.value });
  }

  async submit() {
    let temp = [];
    temp.push(this.userData._id);
    let formData = new FormData();
    formData.append('id', JSON.stringify(temp));
    formData.append('questions', JSON.stringify(this.questions));

    await this.apiService.updateUser(formData).subscribe(async (r: any) => {
      await this.apiService.getAllUsers().subscribe(async (res: any) => {
        this.allUsersQues  = res.data.filter((user) => {
          if(user.questions.length != 0) {
            return user.questions
          }
        });
        // let i:any = 0;
        this.profilesSelection = [];

        await this.questions.map(async (ques) => {
          // this.profilesSelection[i] = [];
          this.allUsersQues.filter((user) => {
            let userQuesAns = user.questions.filter((q) => q.question == ques.question);
            if(userQuesAns.length != 0) {
              if(userQuesAns[0].answers[0].text == ques.answers[0].text) {
                // this.profilesSelection[i].push(user.profiles);
                this.profilesSelection.push(user.profiles);
              }
            }
          });
          // i = i+1;
        });
        let count = {};
        for(let p of this.profiles) {
          count[p._id] = 0;
        }
        this.profilesSelection.forEach(function(e){
          if(e != null) {
            if(count.hasOwnProperty(e))
              count[e]++;
            else
              count[e]=1;
          }
        })
        console.log(count);
        localStorage.setItem("ProfileSimilarityCount", JSON.stringify(count));
      });
      this.router.navigate(['/welcome']);
    });
  }
}
